import { Outlet } from 'react-router';
import { BRAND } from '@/lib/brand';

export default function AdminAuthLayoutV2() {
  return (
    <div className="relative flex min-h-screen flex-col bg-charcoal-800 font-marketing-body text-white">
      {/* Grid background */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        aria-hidden="true"
        style={{
          backgroundImage:
            'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
          backgroundSize: '64px 64px',
        }}
      />

      {/* Top bar */}
      <header className="relative z-10 flex items-center justify-between px-8 py-5">
        <div className="flex items-center gap-3">
          <img src={BRAND.assets.mark} alt={BRAND.name} className="h-7 w-7" />
          <span className="font-marketing-display text-[18px] font-bold tracking-[-0.015em] text-white">
            {BRAND.name}
          </span>
          <span className="border-2 border-lime-500 bg-lime-500/10 px-2 py-0.5 font-marketing-mono text-[10px] font-bold uppercase tracking-[0.14em] text-lime-400">
            Admin
          </span>
        </div>
        <span className="hidden font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-charcoal-200 md:inline">
          Console · accès restreint
        </span>
      </header>

      {/* Main */}
      <main className="relative z-10 flex flex-1 items-center justify-center px-4 py-12 md:py-16">
        <div className="w-full max-w-[440px]">
          <Outlet />
        </div>
      </main>

      {/* Footer strip */}
      <footer className="relative z-10 border-t border-charcoal-700 px-8 py-4">
        <div className="flex items-center justify-between font-marketing-mono text-[10px] uppercase tracking-[0.14em] text-charcoal-400">
          <span>© 2026 Velko · Admin</span>
          <span>Cameroun · OHADA</span>
        </div>
      </footer>
    </div>
  );
}
